import React, { useState, useEffect } from 'react'
import BasicPagination from '../Pagination';
import { GET_WITH_TOKEN } from '../../Backend/Bakend';
import { showToast } from '../Constent/Toast';

const YourBooking = () => {
    const [bookingsData, setBookingsData] = useState([]);
    const [totalPage, setTotalPage] = useState(0);
    const [CurrentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [selectedBooking, setSelectedBooking] = useState(null);
    const [statusDraft, setStatusDraft] = useState('');
    const [statusSaving, setStatusSaving] = useState(false);

    useEffect(() => {
        getBookings(1);
    }, []);

    const getBookings = (page) => {
        setLoading(true);
        setBookingsData([]);
        GET_WITH_TOKEN(`/api/bookings?page=${page}&search=${search}`, "", 
            success => {
                setLoading(false);
                if (success?.data?.data) {
                    setBookingsData(success.data.data);
                    setTotalPage(success.data.last_page);
                    setCurrentPage(success.data.current_page);
                } else if (success?.data && Array.isArray(success.data)) {
                    setBookingsData(success.data);
                } else if (Array.isArray(success)) {
                    setBookingsData(success);
                }
            }, 
            error => {
                setLoading(false);
                console.log(error);
                showToast(error?.message || "Failed to fetch bookings");
            }, 
            fail => {
                setLoading(false);
                console.log(fail);
                showToast(fail?.message || fail?.msg || "Something went wrong");
            }
        );
    };

    const handleSearch = () => {
        getBookings(1);
    };

    const handleReset = () => {
        setSearch('');
        setTimeout(() => {
            getBookings(1);
        }, 100);
    };

    const viewBookingDetails = (booking) => {
        setSelectedBooking(booking);
        // Pre-fill the editor with the current status (normalised to a label)
        const s = booking?.status != null ? String(booking.status).toLowerCase() : '';
        const mapToLabel = { '0': 'pending', '1': 'confirmed', '2': 'cancelled', pending: 'pending', confirmed: 'confirmed', cancelled: 'cancelled' };
        setStatusDraft(mapToLabel[s] || 'pending');
    };

    const saveStatus = async () => {
        if (!selectedBooking?.id || !statusDraft) return;
        setStatusSaving(true);
        try {
            const res = await fetch(
                `https://api.placestovisitindia.com/api/bookings/${selectedBooking.id}/status`,
                {
                    method: 'PATCH',
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('Token')}`,
                    },
                    body: JSON.stringify({ status: statusDraft }),
                }
            );
            const body = await res.json();
            if (!res.ok) {
                showToast(body?.message || 'Failed to update status');
            } else {
                showToast('Status updated');
                const updated = body?.data || { ...selectedBooking, status: statusDraft };
                setSelectedBooking(updated);
                setBookingsData((rows) => rows.map((r) => (r.id === updated.id ? updated : r)));
            }
        } catch (e) {
            showToast(e?.message || 'Network error');
        } finally {
            setStatusSaving(false);
        }
    };

    const fmtDate = (s) => {
        if (!s) return '';
        const d = new Date(s);
        if (isNaN(d.getTime())) return s; // fall back to raw if not parseable
        return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
    };

    const fmtTravelRange = (booking) => {
        const from = fmtDate(booking?.travel_date_from || booking?.travel_date);
        const to   = fmtDate(booking?.travel_date_to);
        if (from && to) return `${from} – ${to}`;
        return from || to || '-';
    };

    const getStatusBadge = (status) => {
        const statusStr = status != null ? String(status) : '';
        const statusLower = statusStr.toLowerCase();
        let badgeClass = 'bg-secondary';
        if (statusLower === 'confirmed' || statusLower === '1') badgeClass = 'bg-success';
        else if (statusLower === 'pending' || statusLower === '0') badgeClass = 'bg-warning text-dark';
        else if (statusLower === 'cancelled' || statusLower === '2') badgeClass = 'bg-danger';
        
        // Display friendly status text
        let displayText = statusStr || 'N/A';
        if (statusLower === '0') displayText = 'Pending';
        else if (statusLower === '1') displayText = 'Confirmed';
        else if (statusLower === '2') displayText = 'Cancelled';
        
        return <span className={`badge ${badgeClass}`}>{displayText}</span>;
    };

    return (
        <div>
            <div className='container mt-1'>
                <div className='row'>
                    <div className='col-lg-12'>
                        <div className='card'>
                            <div className='card-header'>
                                <p style={{ fontSize: '25px' }}>Bookings</p>

                                <div className="mb-3 mt-4 d-flex">
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        placeholder="Enter Name"
                                        style={{ width: '20%' }}
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                        onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                                    />

                                    <button 
                                        type='button' 
                                        className='ms-4' 
                                        onClick={handleSearch}
                                        style={{ backgroundColor: '#008c93', color: '#fff', border: 'none', padding: '7px 15px', borderRadius: '8px' }}
                                    >
                                        Search
                                    </button>

                                    <button 
                                        type='button' 
                                        className='ms-2' 
                                        onClick={handleReset}
                                        style={{ backgroundColor: 'transparent', color: '#000', padding: '7px 15px', borderRadius: '8px', border: '1px solid gray' }}
                                    >
                                        Reset
                                    </button>
                                </div>
                            </div>

                            <div className='card-body' style={{ height: 550, overflowY: "scroll" }}>
                                <p style={{ fontSize: '20px' }}>View All Bookings</p>

                                {loading ? (
                                    <div className="text-center py-5">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <p className="mt-2">Loading bookings...</p>
                                    </div>
                                ) : bookingsData?.length > 0 ? (
                                    <table className="table table-striped table-hover">
                                        <thead>
                                            <tr>
                                                <th scope="col">#</th>
                                                <th scope="col">Name</th>
                                                <th scope="col">Place</th>
                                                <th scope="col">Mobile</th>
                                                <th scope="col">Email</th>
                                                <th scope="col">Travel Date</th>
                                                <th scope="col">Status</th>
                                                <th scope="col">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {bookingsData.map((booking, index) => (
                                                <tr key={booking.id || index}>
                                                    <th scope="row">{(CurrentPage - 1) * 10 + index + 1}</th>
                                                    <td>{booking.customer_name || booking.name || '-'}</td>
                                                    <td>{booking.place || '-'}</td>
                                                    <td>{booking.mobile || '-'}</td>
                                                    <td>{booking.email || '-'}</td>
                                                    <td>{fmtTravelRange(booking)}</td>
                                                    <td>{getStatusBadge(booking.status)}</td>
                                                    <td>
                                                        <button
                                                            className="btn btn-sm btn-info"
                                                            style={{
                                                                backgroundColor: '#17a2b8',
                                                                color: '#fff',
                                                                border: 'none',
                                                                borderRadius: '4px',
                                                                padding: '5px 15px'
                                                            }}
                                                            onClick={() => viewBookingDetails(booking)}
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#viewBookingModal"
                                                        >
                                                            View
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                ) : (
                                    <div className="data-not-found text-center py-5">
                                        <h2 className="bounce">Data Not Found</h2>
                                        <p className="fade-in">Sorry, the requested data could not be found.</p>
                                    </div>
                                )}
                            </div>

                            {totalPage > 1 && (
                                <div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex', padding: '15px 0' }}>
                                    <BasicPagination count={totalPage} reverse onChange={(e) => getBookings(e)} />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* View Booking Details Modal */}
            <div className="modal fade" id="viewBookingModal" tabIndex="-1" aria-labelledby="viewBookingModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header" style={{ backgroundColor: '#008c93', color: '#fff' }}>
                            <h5 className="modal-title" id="viewBookingModalLabel">Booking Details</h5>
                            <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {selectedBooking ? (
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <div className="card h-100">
                                            <div className="card-header bg-light">
                                                <strong>Customer Information</strong>
                                            </div>
                                            <div className="card-body">
                                                <p><strong>Name:</strong> {selectedBooking.customer_name || selectedBooking.name || '-'}</p>
                                                <p><strong>Email:</strong> {selectedBooking.email || '-'}</p>
                                                <p><strong>Mobile:</strong> {selectedBooking.mobile || '-'}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <div className="card h-100">
                                            <div className="card-header bg-light">
                                                <strong>Travel Information</strong>
                                            </div>
                                            <div className="card-body">
                                                <p><strong>Place:</strong> {selectedBooking.place || '-'}</p>
                                                <p><strong>Travel From:</strong> {fmtDate(selectedBooking.travel_date_from) || '-'}</p>
                                                <p><strong>Travel To:</strong> {fmtDate(selectedBooking.travel_date_to) || '-'}</p>
                                                <p className="mb-1"><strong>Status:</strong> {getStatusBadge(selectedBooking.status)}</p>
                                                <div className="d-flex align-items-center mt-2" style={{ gap: 8 }}>
                                                    <select
                                                        className="form-select form-select-sm"
                                                        style={{ maxWidth: 160 }}
                                                        value={statusDraft}
                                                        onChange={(e) => setStatusDraft(e.target.value)}
                                                    >
                                                        <option value="pending">Pending</option>
                                                        <option value="confirmed">Confirmed</option>
                                                        <option value="cancelled">Cancelled</option>
                                                    </select>
                                                    <button
                                                        className="btn btn-sm"
                                                        disabled={statusSaving}
                                                        onClick={saveStatus}
                                                        style={{
                                                            backgroundColor: '#008c93',
                                                            color: '#fff',
                                                            border: 'none',
                                                            borderRadius: 4,
                                                            padding: '4px 14px',
                                                            opacity: statusSaving ? 0.6 : 1,
                                                        }}
                                                    >
                                                        {statusSaving ? 'Saving…' : 'Update'}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-header bg-light">
                                                <strong>Traveller Details</strong>
                                            </div>
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <p><strong>Total Travellers:</strong> {selectedBooking.no_of_travellers || '-'}</p>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <p><strong>Kids:</strong> {selectedBooking.kids_number || '-'}</p>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <p><strong>Elders:</strong> {selectedBooking.elder_number || '-'}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {(selectedBooking.package || selectedBooking.package_id) && (
                                        <div className="col-12 mt-3">
                                            <div className="card">
                                                <div className="card-header bg-light">
                                                    <strong>Package</strong>
                                                </div>
                                                <div className="card-body">
                                                    <p className="mb-0">
                                                        <strong>Name:</strong>{' '}
                                                        {selectedBooking.package?.title || selectedBooking.package_name || '—'}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {selectedBooking.message && (
                                        <div className="col-12 mt-3">
                                            <div className="card">
                                                <div className="card-header bg-light">
                                                    <strong>Additional Message</strong>
                                                </div>
                                                <div className="card-body">
                                                    <p>{selectedBooking.message}</p>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {selectedBooking.created_at && (
                                        <div className="col-12 mt-3">
                                            <p className="text-muted small">
                                                <strong>Booking Created:</strong> {new Date(selectedBooking.created_at).toLocaleString()}
                                            </p>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <p className="text-center">No booking selected</p>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default YourBooking
